import { IAppState } from 'src/store/types';

export const getCurrentPanorama = (state: IAppState) => state.panorama.currentPanorama;
export const getAvailablePanoramas = (state: IAppState) => state.panorama.availablePanoramas;
export const getLookAtMyPano = (state: IAppState) => state.panorama.lookAtMyPanorama;
